import { REQUEST_HOME, RECEIVE_HOME, ERROR_RECEIVE_HOME } from '../Actions/Home';

const initialState = {
  isFetching: false,
  items: [],
  lastUpdated: null,
  error: null,
};

const Home = ( state = initialState, action ) => {
  switch (action.type) {

    case REQUEST_HOME:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_HOME:
      return {
        ...state,
        isFetching: false,
        items: action.items,
        lastUpdated: Date.now(),
      };
    case ERROR_RECEIVE_HOME:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };

    default:
      return state
  }
}

export default Home